module.exports = __webpack_public_path__ + "img/pro_one_3.5b5894dd.jpg";